import React from "react"

// import Auth from "auth";
import { API } from "API"
import { APIPost, APIGet } from "services/APIRequest"
import {arrayObject} from "ConvertKey"
import UrlServer from "configs/UrlServer"
import { ErrorsCallback, SuccessConfirm } from "alertService"
import * as Alert from "alertService"
import Auth from "auth"

// @material-ui/core components =====
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons =====
import AddCircleIcon from "@material-ui/icons/AddCircle";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import EditIcon from "@material-ui/icons/Edit";
import AssignmentIcon from '@material-ui/icons/Assignment';
// import DeleteForeverIcons from "@material-ui/icons/DeleteForever";
// import Check from "@material-ui/icons/Check";

// core components =====
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import NavPills from "components/NavPills/NavPills";

// ComponentsPage =====
import ListsPage from "./Lists";
import CreatePage from "./Create";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  mt4: {
    marginTop: "30px"
  },
  titleIcon: {
    marginBottom: -7 
  }
}
class ManagementPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modeName:"",
      currentPage: 0,
      currentData: null,
      dataListDealerTag:null
    }
  } 

  componentDidMount() { 
    // Alert.Loading(true)
    this.loadDealerStatusTagList(()=>{ 
      // Alert.LoadingClose()
      var loc = window.location.pathname 
      if(loc.indexOf("/noCheck/pr/") != -1){
        this.setState({modeName:"no_check"},()=>{this.updateCerrntId()})
      }else if(loc.indexOf("/checked/pr/") != -1){
        this.setState({modeName:"checked"},()=>{this.updateCerrntId()})
      }else if(loc.indexOf("/checkSuccess/pr/") != -1){
        this.setState({modeName:"check_success"},()=>{this.updateCerrntId()})
      }
    })
  }
  updateCerrntId = ()=>{
    // this.props.match.params.id 
  }
  loadDealerStatusTagList = (callback)=>{ 
    APIPost( UrlServer.URL_POST_DEALER_TAG_STATUS_LIST,{},({datas})=>{ 
      var newConvertDatas = arrayObject(datas,[
        {
          oldKey:"_id",
          newKey:"value"
        },
        {
          oldKey:"description",
          newKey:"name"
        }, 
      ]
      )
      this.setState({  
          dataListDealerTag:newConvertDatas
        },()=>{ 
          callback()
        }); 
    })  
  }
  setTabIndex = (index,callback) => {
    var inv = setTimeout(() => {
      clearInterval(inv)
      this.setState({currentPage:index},()=>{
        if(index === 0){
          this.setState({currentData:null},()=>{
            if(callback)callback()
          })
        }else{
          if(callback)callback()
        }
      })
    }, 150);
  }
  getTabIndex = (index) => {
    if(index === 0){
      this.setState({currentData:null},()=>{
        if(this.state.currentPage !== 0){
          var inv = setTimeout(() => {
            clearInterval(inv)
            this.setState({currentPage:0})
          }, 50);
        }
      })
    }
  }
  setcurrentData = (dataObject) => {
    this.setState({currentData:dataObject})
  }
  render() {
    const { classes } = this.props 
    return (
      <GridContainer>
        <GridItem xs={12}> 
          {
            (
              this.state.dataListDealerTag &&
              this.state.modeName
            )?
              <NavPills
                onChangeTabIndex={this.getTabIndex}
                color="info"
                active={this.state.currentPage}
                tabs={[
                  { 
                    tabIcon: FormatListNumberedIcon,
                    tabButton: "รายการ",
                    tabContent: <ListsPage 
                                  id = {this.props.match.params.id}
                                  modeName = {this.state.modeName}
                                  callbacksetTabIndex = {this.setTabIndex} 
                                  callbackSetCurrentData = {this.setcurrentData}
                                />
                  },
                  {
                    tabIcon: AssignmentIcon,
                    tabButton: "รายละเอียด", 
                    disabled:true,
                    tabContent: <CreatePage   
                                  id = {this.props.match.params.id}
                                  modeName = {this.state.modeName}
                                  currentData={this.state.currentData}
                                  callbacksetTabIndex = {this.setTabIndex} 
                                  dataListDealerTag = {this.state.dataListDealerTag}
                                />
                  }
                ]}
              />
            :""
          } 
        </GridItem> 
      </GridContainer>
    )
  }
}

export default withStyles(styles)(ManagementPage)
